<template>
  <div class="row">
    <div class="col-xxl-7 col-xxxl-6">
      <WhatHappening />

      <div class="row">
        <div class="col-lg-6 col-xxxl-6 col-md-6">
          <ExpectedEarnings />
        </div>
        <div class="col-lg-6 col-xxxl-6 col-md-6">
          <AverageDailySales />
        </div>
        <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
          <RevenueThisMonth />
        </div>
        <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
          <NewCustomersThisMonth />
        </div>
      </div>
    </div>
    <div class="col-xxl-5 col-xxxl-6">
      <StatsBoxes />

      <WeeklySales />
    </div>
    <div class="col-xxl-4">
      <SalesByPOSLocation />
    </div>
    <div class="col-xxl-4">
      <TopSellingProducts />
    </div>
    <div class="col-xxl-4">
      <WebsiteVisitors />
    </div>
    <div class="col-xxl-6">
      <ProductsOrders />
    </div>
    <div class="col-xxl-6">
      <StockReport />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import WhatHappening from "../../template-components/Dashboard/Ecommerce/WhatHappening.vue";

import ExpectedEarnings from "../../template-components/Dashboard/Ecommerce/ExpectedEarnings.vue";

import AverageDailySales from "../../template-components/Dashboard/Ecommerce/AverageDailySales.vue";

import RevenueThisMonth from "../../template-components/Dashboard/Ecommerce/RevenueThisMonth.vue";

import NewCustomersThisMonth from "../../template-components/Dashboard/Ecommerce/NewCustomersThisMonth.vue";

import StatsBoxes from "../../template-components/Dashboard/Ecommerce/StatsBoxes/index.vue";

import WeeklySales from "../../template-components/Dashboard/Ecommerce/WeeklySales.vue";

import SalesByPOSLocation from "../../template-components/Dashboard/Ecommerce/SalesByPOSLocation.vue";

import TopSellingProducts from "../../template-components/Dashboard/Ecommerce/TopSellingProducts/index.vue";

import WebsiteVisitors from "../../template-components/Dashboard/Ecommerce/WebsiteVisitors.vue";

import ProductsOrders from "../../template-components/Dashboard/Ecommerce/ProductsOrders/index.vue";

import StockReport from "../../template-components/Dashboard/Ecommerce/StockReport/index.vue";

export default defineComponent({
  name: "EcommercePage",
  components: {
    WhatHappening,
    ExpectedEarnings,
    AverageDailySales,
    RevenueThisMonth,
    NewCustomersThisMonth,
    StatsBoxes,
    WeeklySales,
    SalesByPOSLocation,
    TopSellingProducts,
    WebsiteVisitors,
    ProductsOrders,
    StockReport,
  },
});
</script>